import * as React from "react";

// 3-tier breakpoints (must match use-mobile.tsx)
const TABLET_MIN_BREAKPOINT = 768;
const TABLET_MAX_BREAKPOINT = 1025; // exclusive — desktop is >= 1025

export function useIsTablet() {
  const [isTablet, setIsTablet] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const checkTablet = () => {
      const width = window.innerWidth;
      setIsTablet(width >= TABLET_MIN_BREAKPOINT && width < TABLET_MAX_BREAKPOINT);
    };
    const mqlMin = window.matchMedia(`(min-width: ${TABLET_MIN_BREAKPOINT}px)`);
    const mqlMax = window.matchMedia(`(max-width: ${TABLET_MAX_BREAKPOINT - 1}px)`);
    const onChange = () => checkTablet();
    mqlMin.addEventListener("change", onChange);
    mqlMax.addEventListener("change", onChange);
    checkTablet();
    return () => {
      mqlMin.removeEventListener("change", onChange);
      mqlMax.removeEventListener("change", onChange);
    };
  }, []);

  return !!isTablet;
}

// Combined hook for device detection
export function useDeviceType() {
  const [deviceType, setDeviceType] = React.useState<'mobile' | 'tablet' | 'desktop'>('desktop');

  React.useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      if (width < TABLET_MIN_BREAKPOINT) setDeviceType('mobile');
      else if (width < TABLET_MAX_BREAKPOINT) setDeviceType('tablet');
      else setDeviceType('desktop');
    };
    window.addEventListener('resize', checkDevice);
    checkDevice();
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return {
    deviceType,
    isMobile: deviceType === 'mobile',
    isTablet: deviceType === 'tablet',
    isDesktop: deviceType === 'desktop',
    isMobileOrTablet: deviceType === 'mobile' || deviceType === 'tablet',
  };
}
